import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import Mobile from './components/Mobile';
import Desktop from './components/Desktop';
import { getDefaultBreakpoint } from '../../core/util/device/screen';

type Props = {
  show911Section?: boolean;
  showMiddleSection?: boolean;
  showBottomSection?: boolean;
  showSocial?: boolean;
  showHIPAAAuthorization?: boolean;
};

const AppFooter = (props: Props) => {
  const {
    show911Section = true,
    showMiddleSection = true,
    showBottomSection = true,
    showSocial = true,
    showHIPAAAuthorization = true,
  } = props;

  return (
    <footer id="footer">
      <Hidden initialWidth={getDefaultBreakpoint()} smDown>
        <Desktop
          show911Section={show911Section}
          showBottomSection={showBottomSection}
          showHIPAAAuthorization={showHIPAAAuthorization}
          showMiddleSection={showMiddleSection}
          showSocial={showSocial}
        />
      </Hidden>
      <Hidden initialWidth={getDefaultBreakpoint()} mdUp>
        <Mobile
          show911Section={show911Section}
          showBottomSection={showBottomSection}
          showHIPAAAuthorization={showHIPAAAuthorization}
          showMiddleSection={showMiddleSection}
          showSocial={showSocial}
        />
      </Hidden>
    </footer>
  );
};

export default AppFooter;
